import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NoContentComponent } from './no-content/no-content.component';

const routes: Routes = [
	{path: 'staffels', loadChildren: 'app/tiers/tiers.module#TiersModule'},
	{path: 'verspreiders', loadChildren: 'app/distributors/distributors.module#DistributorsModule'},
	{path: 'belastingen', loadChildren: 'app/taxes/taxes.module#TaxesModule'},
	{path: 'facturen', loadChildren: 'app/invoices/invoices.module#InvoicesModule'},
	{path: 'voorkeurverspreiders', loadChildren: 'app/preferreddistributors/distributors.module#DistributorsModule'},
	{path: 'postcodes', loadChildren: 'app/postcodes/postcodes.module#PostcodesModule'},
	{path: 'klanten', loadChildren: 'app/customers/customers.module#CustomersModule'},
	{path: '**', component: NoContentComponent}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule
{
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts